import { render, staticRenderFns } from "./create-rfp[project].vue?vue&type=template&id=25846f79&"
import script from "./create-rfp[project].vue?vue&type=script&lang=js&"
export * from "./create-rfp[project].vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports